import React, { useEffect, useState } from "react";

import { FaUsers, FaUserAlt } from "react-icons/fa";
import useAxiosPost from "../../../hooks/useAxiosPost";
import SingleCard from "./SingleCard";

const ActiveUsersCard = ({}) => {
  const [
    postApiData,
    apiResponse,
    apiError,
    apiLoading,
    apiMessage,
    apiErrorCount,
  ] = useAxiosPost<ResponseProp>(
    "reports/dashboard/getActiveUsersCountByOwner"
  );
  const [value, setValue] = useState<string>("0");
  useEffect(() => {
    postApiData({});
  }, []);
  useEffect(() => {
    if (apiResponse !== null) {
      const data: any = apiResponse.responseData;
      const totalActiveUsers = data.totalActiveUsers;
      console.log({ totalActiveUsers });
      setValue(totalActiveUsers);
    }
  }, [apiResponse]);
  return (
    <SingleCard
      label="Active Users"
      value={value}
      CardIcon={FaUserAlt}
      iconColor="#20c997"
      isLoading={apiLoading}
      isLink
      route="/pppoe-users?activeTab=active"
    />
  );
};

export default ActiveUsersCard;
